import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Cloud from './Cloud';

export default class CloudMaker extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);
    this.spawnWaiter = 1;
    this.cloudName = UIAssetKeys._Cloud_1;

    this.cloudLayers = [];
    let cloudprops = { minScale: 2, maxScale: 5, minSpeed: 10, maxSpeed: 20 };
    this.cloudLayers.push(cloudprops);
    cloudprops = { minScale: 5, maxScale: 7, minSpeed: 22, maxSpeed: 39 };
    this.cloudLayers.push(cloudprops);
    cloudprops = { minScale: 8, maxScale: 10, minSpeed: 40, maxSpeed: 49 };
    this.cloudLayers.push(cloudprops);

    // create a pool of 20 clouds
    this.cloudPool = [];
    for (let i = 0; i < 20; i++) {
      this.cloudPool.push(new Cloud(this.scene));
    }

    /** @type {Cloud[]} */
    this.activeClouds = [];

    for (let i = 0; i < 5; i++) {
      this.makeInitialClouds();
    }
  }

  makeInitialClouds () {
    const cloud = this.cloudPool.pop();
    if (cloud === null) return;
    const layer = this.cloudLayers[Phaser.Math.Between(1, this.cloudLayers.length) - 1];
    const speed = Phaser.Math.Between(layer.minSpeed, layer.maxSpeed);
    const scale = Phaser.Math.Between(layer.minScale, layer.maxScale) / 10;
    const startX = Phaser.Math.Between(100,this.scene.scale.width - 100);
    const startY = Phaser.Math.Between(1,200) - 20;
    const endX = -222;
    cloud.reset(this.cloudName, speed, startX, startY, endX, scale);
    this.activeClouds.push(cloud);
    this.add(cloud);
  }

  spawnCloud () {
    const cloud = this.cloudPool.pop();
    if (cloud === null) return;
    const layer = this.cloudLayers[Phaser.Math.Between(1, this.cloudLayers.length) - 1];
    const speed = Phaser.Math.Between(layer.minSpeed, layer.maxSpeed);
    const scale = Phaser.Math.Between(layer.minScale, layer.maxScale) / 10;
    const startX = this.scene.scale.width;
    let yoff = -20;
    if (this.cloudName === UIAssetKeys._NightCloud_1) {
      yoff = 60;
    }
    const startY = Phaser.Math.Between(1,200) + yoff;
    const endX = -222;
    cloud.reset(this.cloudName, speed, startX, startY, endX, scale);
    this.activeClouds.push(cloud);
    this.add(cloud);
  }

  returnCloud (i) {
    const cloud = this.activeClouds[i];
    this.remove(cloud);
    this.scene.children.remove(cloud);
    this.cloudPool.push(cloud);
    this.activeClouds.splice(i,1);
  }

  changeToNight () {
    this.cloudName = UIAssetKeys._NightCloud_1;
    const len = this.activeClouds.length;
    for (let i = 0; i < len; i++) {
      this.activeClouds[i].switchSprite(this.cloudName);
    }
  }

  changeToDay () {
    this.cloudName = UIAssetKeys._Cloud_1;
    const len = this.activeClouds.length;
    for (let i = 0; i < len; i++) {
      this.activeClouds[i].switchSprite(this.cloudName);
    }
  }

  tick (dt) {
    const len = this.activeClouds.length - 1;
    for (let i = len; i >= 0; i--) {
      if (this.activeClouds[i].x < this.activeClouds[i].destX) {
        this.returnCloud(i);
        continue;
      }
      this.activeClouds[i].tick(dt);
    }
    if (this.spawnWaiter <= 0) {
      this.spawnCloud();
      this.spawnWaiter = Phaser.Math.Between(40,68) / 10;
    }
    else {
      this.spawnWaiter -= dt;
    }
  }
}